

export const APP_NAVIGATION_ROUTES  = {
    dashboard: "/",
    chats: "/chats",
    externalLeads: "/external-leads"
}